interface Feature {
  icon: string;
  title: string;
  description: string;
}

export default function Features({ features }: { features: Feature[] }) {
  return (
    <section className="w-full py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-star-line text-xs"></i>
            核心功能
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            为团队创作而生的<span className="text-primary-600">六大核心能力</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            从素材管理到成品发布，一起草视频覆盖视频创作的全链路，让团队协作从未如此流畅
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2.5">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}